import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { style: {"color":"#f56c6c"} }

import { ref, PropType, computed, watch, Ref } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import SelectOperator from '@/components/SelectOperator.vue'
import SelectPayee from '@/components/SelectPayee.vue'
import StrategyPayeeConfig from './StrategyPayeeConfig.vue'
import { upsertProfitsharingStrategy } from '@/api/operation'
import { ElMessage, ElMessageBox } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import FormRulesFactory from '@/common/formRules'
import InfoTooltip from '@/components/InfoTooltip.vue'
import { ProfitSharingSource } from '@/types/types'


import { defineComponent, nextTick } from 'vue'

const __default__ = defineComponent({
  name: 'StrategyUpsert',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
  },
  info: {
    type: Object,
    default: () => ({}),
  },
  operatorId: {
    type: String,
    default: '',
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { expose, emit }) {

const props = __props

const activityFormRule = ref({
  ...FormRulesFactory.generateCustomRules(
    ['operatorId', 'payeeType', 'ower.payeeId'],
    'selectNone',
    'selectNone',
  ),
  ...FormRulesFactory.generateCustomRules(
    ['payeeName', 'bankCard', 'bankCode', 'bankCardName', 'name'],
    'inputEmpty',
    'inputInvalid',
  ),
})
const activityTmplItems = ref()
const { profitSharingSources, getProfitSharingSourceDesc } = useProtocolEnums()

const { t, tl } = useI18nTl('Operation')



let subsForm = ref()
const clearValidate = () => {
  console.log('clearValidate')
  nextTick(() => {
    let t = setTimeout(() => {
      clearTimeout(t)
      subsForm.value?.clearValidate()
    })
  })
}

const record = ref<Record<string, any>>({})
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
    if (!val) {
      subsForm.value?.clearValidate()
      record.value = { source: ProfitSharingSource.PSS_SERVICE_AMOUNT, ower: {}, payees: [] }
    }
  },
})

const submit = async () => {
  if (activityTmplItems.value) activityTmplItems.value.validate()
  await subsForm.value?.validate()

  var sum = 0
  record.value.payees.forEach((item: any) => {
    sum += Number(item.percentage)
  })
  if (sum != 100) {
    ElMessage.error(t(`Operation.profitSharingPercentageDesc`))
    return
  }

  upsertProfitsharingStrategy({ strategy: record.value }).then((res: any) => {
    if (props.isEdit) {
      ElMessage.success(t(`Base.editSuccess`))
    } else {
      ElMessage.success(t(`Base.createSuccess`))
    }
    showDialog.value = false
    emit('submitted')
  })
}

watch(
  () => props.modelValue,
  (val) => {
    console.log('props.info:', props.info)
    if (props.isEdit) {
      record.value = JSON.parse(JSON.stringify(props.info))
    } else {
      record.value = {
        operatorId: props.operatorId,
        source: ProfitSharingSource.PSS_SERVICE_AMOUNT,
        ower: {},
        payees: [],
      }
    }
  },
  { immediate: true },
)
expose({
  clearValidate,
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: props.isEdit ? _unref(tl)('editStrategy') : _unref(tl)('addStrategy'),
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "50%",
    "z-index": 1999,
    "custom-class": "evse-drawer",
    "destroy-on-close": true
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.$hasPermission('post'),
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.isEdit ? _ctx.$t('Base.saveChanges') : _ctx.$t('Base.add')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        ref_key: "subsForm",
        ref: subsForm,
        rules: activityFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.name'),
                    prop: "name",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.name) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator'),
                    prop: "operatorId",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      (!props.isEdit)
                        ? (_openBlock(), _createBlock(SelectOperator, {
                            key: 0,
                            modelValue: record.value.operatorId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.operatorId) = $event))
                          }, null, 8, ["modelValue"]))
                        : (_openBlock(), _createBlock(_component_el_input, {
                            key: 1,
                            modelValue: record.value.operatorName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.operatorName) = $event)),
                            disabled: true
                          }, null, 8, ["modelValue"]))
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('profitSharingSource'),
                    prop: "source",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.source,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((record.value.source) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(profitSharingSources), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('strategyOwer'),
                    prop: "ower.payeeId",
                    required: ""
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("label", null, _toDisplayString(_unref(tl)('strategyOwer')), 1),
                      _createVNode(InfoTooltip, {
                        content: _unref(tl)('strategyOwerDesc')
                      }, null, 8, ["content"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(SelectPayee, {
                        modelValue: record.value.ower.payeeId,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((record.value.ower.payeeId) = $event)),
                        disabled: record.value.operatorId == '0' || !record.value.operatorId
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "name",
                    required: ""
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("label", null, _toDisplayString(_unref(getProfitSharingSourceDesc)(record.value.source)) + _toDisplayString(_unref(tl)('profitSharingConfig')), 1),
                      _createElementVNode("label", _hoisted_1, "（ " + _toDisplayString(_unref(tl)('profitSharingPercentageDesc')) + " ）", 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(StrategyPayeeConfig, {
                        list: record.value.payees,
                        operatorID: record.value.operatorId,
                        isEdit: props.isEdit,
                        style: {"width":"100%"}
                      }, null, 8, ["list", "operatorID", "isEdit"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})